import React from 'react';
import LegalPage, { LegalSection, LegalContactInfo } from '../components/LegalPage';

const Terms = () => {
  return (
    <LegalPage
      title="Terms & Conditions"
      lastUpdated="January 2025"
      intro="Please read these Terms and Conditions carefully before using our services. By booking a tour with Travel Mhor, you agree to these terms."
      footerText="By booking with Travel Mhor, you acknowledge that you have read, understood, and agree to these Terms & Conditions."
    >
      <LegalSection title="1. Booking and Payment">
        <p>All bookings must be confirmed with full payment or a deposit as specified. Payment can be made by credit card, bank transfer, or cash. For group bookings, payment terms may vary and will be communicated separately.</p>
        <p>Prices are subject to change without notice until booking is confirmed. All prices include applicable taxes unless otherwise stated.</p>
      </LegalSection>

      <LegalSection title="2. Cancellation Policy">
        <ul>
          <li><strong>7+ days before tour:</strong> Full refund minus processing fees</li>
          <li><strong>3-6 days before tour:</strong> 50% refund</li>
          <li><strong>Less than 48 hours:</strong> No refund unless due to medical emergency with documentation</li>
          <li><strong>Weather cancellations:</strong> Full refund or rescheduling option</li>
        </ul>
      </LegalSection>

      <LegalSection title="3. Tour Modifications">
        <p>Travel Mhor reserves the right to modify tour itineraries, departure times, or routes due to weather conditions, road closures, safety concerns, or other circumstances beyond our control. We will provide reasonable notice when possible.</p>
        <p>Customers may request modifications to their booking up to 3 days before the tour date, subject to availability and additional fees.</p>
      </LegalSection>

      <LegalSection title="4. Passenger Responsibilities">
        <p>Passengers must:</p>
        <ul>
          <li>Arrive at designated pickup locations on time</li>
          <li>Follow all safety instructions from tour guides and drivers</li>
          <li>Respect other passengers and maintain appropriate behavior</li>
          <li>Not consume alcohol on the bus (except during designated wine tours)</li>
          <li>Be responsible for their personal belongings</li>
          <li>Inform us of any medical conditions or special needs at booking</li>
        </ul>
      </LegalSection>

      <LegalSection title="5. Safety and Liability">
        <p>Travel Mhor maintains comprehensive insurance and follows all safety regulations. However, passengers participate in tours at their own risk. We are not liable for:</p>
        <ul>
          <li>Personal injury due to passenger negligence or failure to follow instructions</li>
          <li>Loss or damage to personal belongings</li>
          <li>Delays or cancellations due to circumstances beyond our control</li>
          <li>Passenger satisfaction with weather conditions or external attractions</li>
        </ul>
      </LegalSection>

      <LegalSection title="6. Health and Medical Conditions">
        <p>Passengers with medical conditions, mobility limitations, or special dietary requirements must inform us at the time of booking. While we strive to accommodate all passengers, some tours may not be suitable for individuals with certain health conditions.</p>
        <p>Passengers are responsible for bringing any required medications and assessing their own fitness for tour activities.</p>
      </LegalSection>

      <LegalSection title="7. Children and Minors">
        <p>Children under 18 must be accompanied by an adult. Children under 3 travel free when sharing a seat with an adult. Car seats are required for children under 8 and must be provided by the guardian or arranged through us at booking.</p>
      </LegalSection>

      <LegalSection title="8. Group Bookings">
        <p>Special terms apply to group bookings (8+ passengers). Group rates, payment schedules, and cancellation policies will be outlined in separate agreements. Groups may be subject to minimum passenger requirements.</p>
      </LegalSection>

      <LegalSection title="9. Photography and Media">
        <p>Travel Mhor may take photographs or videos during tours for promotional purposes. By participating in our tours, you consent to the use of your likeness in our marketing materials unless you specifically opt out.</p>
      </LegalSection>

      <LegalSection title="10. Complaints and Disputes">
        <p>Any complaints should be raised with our tour guide during the tour or reported to our customer service team within 48 hours. We are committed to resolving issues promptly and fairly.</p>
        <p>Disputes will be resolved through mediation or arbitration under the laws of [Jurisdiction].</p>
      </LegalSection>

      <LegalSection title="11. Privacy and Data Protection">
        <p>Personal information collected during booking is used solely for tour operations and customer service. We do not share customer data with third parties except as required by law. See our Privacy Policy for detailed information.</p>
      </LegalSection>

      <LegalSection title="12. Changes to Terms">
        <p>These terms may be updated periodically. Changes will be posted on our website and take effect immediately. Continued use of our services after changes indicates acceptance of new terms.</p>
      </LegalSection>

      <LegalSection title="13. Contact Information">
        <p>For questions about these terms or our services:</p>
        <LegalContactInfo />
      </LegalSection>
    </LegalPage>
  );
};

export default Terms;
